module.exports = __webpack_public_path__ + "static/img/link-mi-cv.2b7abe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/link-mi-cv.jpg
// module id = TIlr
// module chunks = 1